// extracted by mini-css-extract-plugin
export default {"continue":"il-z"};